module.exports = __webpack_public_path__ + "static/media/Mallika Gargeya.6b4488ee.png";